import React from 'react';
import { ContentWrapper } from '../components/content_wrapper/content_wrapper';
import OrgsAbout from '../components/orgs_list/orgs_about';
import OrgsListContainer from '../components/orgs_list/orgs_list_container';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';

export const OrgsPage = () => {
  return (
    <ScrollToTop>
      <ContentWrapper style={{ paddingTop: 48, paddingBottom: 96 }}>
        <OrgsListContainer />
        <OrgsAbout />
      </ContentWrapper>
    </ScrollToTop>
  );
};
export default OrgsPage;
